// FAQ Component Functionality
document.addEventListener('DOMContentLoaded', () => {
  // Initialize the FAQ toggles
  initFaqToggles();
});

// Add Turbo event listeners for various navigation scenarios
document.addEventListener('turbo:load', () => {
  initFaqToggles();
});

// Handle page restoration from cache
document.addEventListener('turbo:before-render', () => {
  // Mark all existing FAQ toggles for cleanup/reinitialization
  document.querySelectorAll('.faq-toggle').forEach(toggle => {
    toggle.dataset.turboRestored = 'true';
  });
});

// Also handle restoration when page is shown (helps with bfcache)
document.addEventListener('turbo:render', () => {
  initFaqToggles();
});

function initFaqToggles() {
  const faqToggles = document.querySelectorAll('.faq-toggle');
  
  faqToggles.forEach(toggle => {
    // Remove any existing event listeners to avoid duplicates
    toggle.removeEventListener('click', toggleFaqItem);
    toggle.addEventListener('click', toggleFaqItem);
    
    // If this is a restored element, check its previous state
    if (toggle.dataset.turboRestored === 'true') {
      const content = toggle.nextElementSibling;
      const icon = toggle.querySelector('.faq-icon');
      
      // If content was previously expanded, restore that state
      if (icon.classList.contains('rotate-180')) {
        content.style.maxHeight = content.scrollHeight + "px";
      }
      
      // Clear the marker
      delete toggle.dataset.turboRestored;
    }
  });
}

function toggleFaqItem() {
  const content = this.nextElementSibling;
  const icon = this.querySelector('.faq-icon');
  
  // Toggle this specific FAQ
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    icon.classList.remove('rotate-180');
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    icon.classList.add('rotate-180');
  }
}

// Export the function to be accessible globally if needed
window.toggleFaq = function(button) {
  const content = button.nextElementSibling;
  const icon = button.querySelector('.faq-icon');
  
  // Toggle this specific FAQ
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    icon.classList.remove('rotate-180');
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    icon.classList.add('rotate-180');
  }
}; 
